import type { ReactNode } from 'react';
import { Text } from '@shared/widgets';

interface ISidebarSectionProps {
  caption?: ReactNode;
  children: ReactNode;
}

export const SidebarSection = (props: ISidebarSectionProps) => {
  return (
    <div className='flex flex-col bg-white dark:bg-soft-black gap-6 p-6'>
      <Text size='sm'>{props.caption}</Text>
      {props.children}
    </div>
  );
};
